import * as yup from 'yup';

const companyStageFinepSchema = yup.object().shape({
    predecessor: yup.string().required(),
    preOperationalOrEarlyGrowth: yup.boolean().required().transform((value, originalValue) => {
        return originalValue === '1';
    }),
});

export default companyStageFinepSchema;